import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=23c451ae&scoped=true"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"
import style0 from "./uploads.vue?vue&type=style&index=0&id=23c451ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c451ae",
  null
  
)

export default component.exports